// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { ThreeDots } from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import { Button, TextField, Typography } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import Image from './images/podme_background.png';
import { Drawer } from '@material-ui/core';
import { GetData } from './SkyShowTimeActication';


const styles = {
  paperContainer: {
    backgroundImage: `url(${Image})`,
    height: '1920vh',
    width: '1080vh'
  }
};


function PodmeActivate(props) {

  const [loading, setLoading] = React.useState();
  const [customerNo, setCustomerNo] = React.useState();
  const [zipCode, setZipCode] = React.useState();
  const [errMsg, setErrMsg] = React.useState();
  const [responseOk, setResponseOk] = React.useState();

  useEffect(() => {

  }, []);




  return (

    <div style={{ backgroundImage: `url(${Image})`, height: '100vh', width: '85vw', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
      <div style={{ width: "1000px" }}>
        <Drawer
          anchor={"right"}
          open={true}
          width={"1000px"}
          variant={"permanent"}
        >
          <div style={{ width: '20vw' }} />

          <center><img src={require('./images/Sappa_Green.png')} style={{  marginTop: '20px',marginLeft:'20px',marginRight:'20px' }} /></center>

          <h4 style={{ margin: "10px" }}>Välkommen att aktivera Podme hos Sappa</h4>
                    
          <TextField value={customerNo} defaultValue='' onChange={(e) => setCustomerNo(e.target.value)} id="customerno" label="Kundnummer" variant="outlined" style={{ margin: "10px" }} />
          <TextField value={zipCode} defaultValue='' onChange={(e) => setZipCode(e.target.value)} id="zipcode" label="Postnummer" variant="outlined" style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "10px" }} />
          <div>
            <Button
              size='medium'
              variant='contained'
              disabled={loading}
              color='primary'
              style={{ margin: "10px"}}
              onClick={() => {

                if (customerNo == null || zipCode == null) {
                  setErrMsg("Du måste ange kundnummer och postnummer.");
                  return;
                }

                setLoading(true);
                setErrMsg("");
                setResponseOk(false);
                //alert("Activate Customer: " + customerNo + " ZipCode: " + zipCode);

                let endpoint = 'https://bundler.sappa.se/api/subscription?customerNumber=' + customerNo + '&zipCode=' + zipCode + "&product=podme";

                fetch(endpoint, { method: 'GET', headers: { Authorization: '756B2751E80F4F908DC946A65FB2CC9F' } })
                  .then(response => {
                    setResponseOk(true);
                    return response.json();
                  })
                  .then(data => {
                    //console.log(data.ActivationUrl);
                    if (data.message.length > 0) {
                      setErrMsg(data.message);
                    }
                    else {
                      if (data.activationUrl.length > 0 && !data.hasActivated) {
                        window.location.replace(data.activationUrl);
                        
                      }
                    }
                    setLoading(false);
                  })
                  .catch(
                    exp => {
                      setLoading(false);
                      console.log(exp);
                    }
                  );

                

              }}>Aktivera</Button>
            <Button size='medium' variant='contained' color='default' style={{ margin: "10px" }} href='/'>Avbryt</Button>
            {/* {ShowLoading(loading)} */}
          </div>
          <div style={{ color: 'red', margin: "10px" }}>{errMsg} </div>
        </Drawer>
      </div>
    </div>
  );
}

export default PodmeActivate;
